import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Layout,
  Avatar,
  StatusText,
  ActionButton,
  HSeperator,
  Title,
  Text,
  SessionContainer,
  Session,
  ActionConatiner,
  PriceInfo,
} from "./Styles";
import { ThemeContext } from "styled-components";
import LocalBooking from "../../Utility/Method/LocalBooking";
import StyledAvatar from "../../UIcomponent/StyledAvatar";
import Urls from "../../Utility/Urls";
import { Redirect, Link } from "react-router-dom";
import StyledLink from "../../UIcomponent/Link";
import DateTime from "../../Utility/Method/DateTime";
import moment from "moment-jalaali";
import LocalContext from "../../Context/LocalContetxt";
import { PersianMonth } from "../../Utility/Method/DateTimeConstant";
import Col from "../../UIcomponent/Column";
import BookingReq from "../../Utility/Requester/BookingReq";
import { Notify } from "../../UIcomponent/NotificationManager";
import { RoutePath } from "../../Utility/RoutePath";
import { getGuid } from "../../App";
import Metas from "../../Component/Metas";

const PaymentStatus = (props) => {
  const { payStatus } = props;
  const theme = useContext(ThemeContext);
  const bookedData = LocalBooking.Get() || null;
  const lang = useContext(LocalContext).lang;
  const [isSubmiting, setIsSubmiting] = useState(false);
  const successStatusString = (count) => {
    if (count === 1) {
      return "کلاس با موفقیت رزرو شد";
    } else {
      return "پکیج با موفقیت رزرو شد";
    }
  };
  useEffect((_) => {
    if (payStatus == 1) {
      if (window.ga)
        window.ga("ec:setAction", "purchase", {
          id: getGuid(),
          step: 5,
        });
    }
  }, []);
  const payment = (ID) => {
    setIsSubmiting(true);
    let data = {
      TeacherID: bookedData.TeacherID,
      LessonID: bookedData.LessonID,
      PriceID: bookedData.PriceID,
      TimeSlots: bookedData.TimeSlots.map((each) => {
        return {
          From: each.date_time_from,
          To: each.date_time_to,
        };
      }),
      VoucherCode:
        bookedData.VoucherCode !== undefined ? bookedData.VoucherCode : null,
    };
    BookingReq.BookLesson(data)
      .then((res) => {
        if (res.data.Redirect !== null) {
          window.location.replace(res.data.Redirect.Action);
        } else {
          window.location.replace(RoutePath.paySuccess);
        }
      })
      .catch((err) => {
        // LocalBooking.Remove()
        setIsSubmiting(false);
        Notify("error", err.response.data.message, 4000);
      });
  };
  return bookedData && bookedData.TeacherInfo ? (
    <Layout xl={23} lg={23} md={23} sm={23} xs={23}>
      <Metas
        title="وضعیت پرداخت | لینگوتاک"
        description="وضعیت پرداخت | لینگوتاک"
      />

      <Container xl={20} lg={23} md={23} sm={23} xs={23}>
        <StatusText payStatus={payStatus}>
          {payStatus === 1
            ? "پرداخت شما با موفقیت انجام شد"
            : "متاسفانه پرداخت شما انجام نشد"}
        </StatusText>
        <HSeperator />
        <Avatar source={Urls.avatar() + bookedData.TeacherInfo.Avatar} />
        <Title>
          {payStatus === 1
            ? " کلاس شما با مشخصات زیر رزرو شد."
            : "لطفا پرداخت خود را با مشخصات زیر مجددا انجام دهید"}
        </Title>
        <HSeperator color={theme.primary} width="40px" height="5px" />
        <Text>
          {bookedData.TeacherInfo.FirstName +
            " " +
            bookedData.TeacherInfo.LastName}
        </Text>
        <SessionContainer xl={22} lg={23} md={23} sm={23} xs={23}>
          {bookedData.TimeSlots.map((each) => {
            return (
              <Session
                payStatus={payStatus}
                xl={5}
                lg={5}
                md={11}
                sm={24}
                xs={24}
              >
                <Col>
                  {
                    DateTime.getDayFullStr(
                      `${moment(each.date_time_from).format("ddd")}`
                    )[`${lang}`]
                  }
                  ,{" "}
                  {moment(each.date_time_from).format("jDD") +
                    " " +
                    PersianMonth[
                      Number(moment(each.date_time_from).format("jMM")) - 1
                    ]}
                </Col>
                <Col>
                  {moment(each.date_time_from).format("HH:mm") +
                    " تا " +
                    moment(each.date_time_to).format("HH:mm")}
                </Col>
              </Session>
            );
          })}
        </SessionContainer>
        <Text
          fontSizelg={theme.fontSizeLg}
          fontSizeSm={theme.fontSizeSm}
          color={theme.textBold}
          style={{
            display: payStatus === -1 && "none",
            fontWeight: 800,
            margin: "15px 0px 15px 0px",
            justifyContent: "flex-start",
          }}
        >
          شما در هر زمان می توانید با مراجعه به بخش
          <Link to="/lessons"> کلاس های من </Link>
          از جزییات کلاس های خود مطلع شده و در زمان مقرر وارد کلاس خود شوید.
        </Text>
        <PriceInfo payStatus={payStatus}>
          <Col>مبلغ قابل پرداخت</Col>
          <Col>
            {(
              (bookedData.PayableAmount -
                (bookedData.VoucherPrice ? bookedData.VoucherPrice : 0)) /
              10
            ).toLocaleString(lang) + " تومان "}
          </Col>
        </PriceInfo>
        <ActionConatiner
          xl={8}
          lg={8}
          md={8}
          xs={23}
          md={23}
          payStatus={payStatus}
        >
          <ActionButton
            primary
            style={{
              display: payStatus === -1 && "none",
            }}
          >
            <StyledLink to={RoutePath.lessons}>کلاس های من</StyledLink>
          </ActionButton>
          <ActionButton
            secondary
            width="240px"
            style={{
              display: payStatus === 1 && "none",
            }}
            onClick={payment}
            loading={isSubmiting}
            disable={isSubmiting}
          >
            پرداخت مجدد
          </ActionButton>
          <ActionButton
            default
            color={theme.primary}
            style={{
              display: payStatus === -1 && "none",
            }}
          >
            <StyledLink to={`/teacher/${bookedData.PublicUsername}`}>
              پروفایل استاد
            </StyledLink>
          </ActionButton>
        </ActionConatiner>
      </Container>
    </Layout>
  ) : (
    <Layout xl={23} lg={23} md={23} sm={23} xs={23}>
      <Container xl={20} lg={23} md={23} sm={23} xs={23}>
        <StatusText payStatus={payStatus}>
          {payStatus === 1
            ? "پرداخت شما با موفقیت انجام شد"
            : "متاسفانه پرداخت شما انجام نشد"}
        </StatusText>
        <HSeperator />
        <Title>
          {payStatus === 1
            ? " کلاس شما رزرو شد."
            : "لطفا پرداخت خود را مجددا انجام دهید"}
        </Title>
        <Text
          fontSizelg={theme.fontSizeLg}
          fontSizeSm={theme.fontSizeSm}
          color={theme.textBold}
          style={{
            display: payStatus === -1 && "none",
            fontWeight: 800,
            margin: "15px 0px 15px 0px",
            justifyContent: "flex-start",
          }}
        >
          شما در هر زمان می توانید با مراجعه به بخش
          <Link to="/lessons"> کلاس های من </Link>
          از جزییات کلاس های خود مطلع شده و در زمان مقرر وارد کلاس خود شوید.
        </Text>
        <ActionConatiner
          xl={8}
          lg={8}
          md={8}
          xs={23}
          md={23}
          payStatus={payStatus}
        >
          <ActionButton primary>
            <StyledLink to={RoutePath.lessons}>کلاس های من</StyledLink>
          </ActionButton>
        </ActionConatiner>
      </Container>
    </Layout>
  );
};

export default PaymentStatus;
